import { use } from "react";



import { useSearchPageFiltersDataContext } from "@faire/retailer/views/search-v2/__internal__/LazySearchPage/__internal__/SearchPage/__internal__/ViewState/SearchPageFiltersDataContext";

export const useSearchPageFiltersQuery = () => {
  const {
    filtersResponse: filtersResponsePromise,
    legacyFiltersResponse,
    isError,
    loading,
    error,
  } = useSearchPageFiltersDataContext();
  if (filtersResponsePromise) {
    const filtersResponse = use(filtersResponsePromise);
    return {
      data: filtersResponse,
      isFetching: loading,
      isError,
      error,
    };
  }
  return {
    data: legacyFiltersResponse,
    isFetching: loading,
    isError,
    error,
  };
};
